__turbopack_context__.v({
  "highlight": "SearchHighlight-module-scss-module__S_kIMG__highlight",
});
